import styled from 'styled-components'
import { themeGet } from 'styled-system'
import {
  AutoTable,
  HeaderTwo,
  ProgressBarIndicator,
} from 'secondstep-components'

export const PathwaysTable = styled(AutoTable)`
  border-radius: ${themeGet('spacing.yellow12_0_75rem')};
  table-layout: fixed;

  [class*='Cell-sc'] {
    font-family: ${themeGet('font.molde.medium')};
    font-size: 0.75rem;
  }

  [class*='sub-title-row'] {
    [class*='Cell']:not([colspan='1']) {
      background-color: ${themeGet('colors.lightBlueGray')};
    }
  }

  [class*='Cell']:not(:not([colspan='1'])) {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 1.125rem;
    min-height: 60px;
    height: 60px;
    font-family: ${themeGet('font.molde.regular')};
    font-size: 1rem;
  }

  [class*='Cell']:not([colspan='1']) {
    background-color: ${themeGet('colors.paleGray')};
    font-family: ${themeGet('font.molde.medium')};
    padding: 0.625rem 1.125rem;
    font-size: 0.8125rem;
    ${themeGet('breakpoints.tablet')} {
      padding-left: ${themeGet('spacing.blue16_1rem')};
      padding-right: ${themeGet('spacing.blue16_1rem')};
    }
    ${themeGet('breakpoints.mobile')} {
      padding-left: ${themeGet('spacing.yellow12_0_75rem')};
    }
  }

  [class*='Cell']:nth-child(2) {
    padding-left: 1.375rem;
    padding-right: ${themeGet('spacing.purple24_1_5rem')};
  }

  [class*='AutoTableHeaderTh-sc'] {
    padding-left: 1.25rem;
    background: ${themeGet('colors.beaconGray')};

    span {
      font-family: ${themeGet('font.molde.medium')};
      font-size: 1rem;
    }

    &:first-child {
      background: ${themeGet('colors.beaconGray')};
    }
  }

  [class*='AutoTableHeaderTh']:nth-of-type(2),
  [class*='AutoTableHeaderTh']:nth-child(2) {
    padding-left: 1.375rem;
  }

  [class*='AutoTableHeaderTh']:nth-of-type(3),
  [class*='AutoTableHeaderTh']:nth-child(3) {
    padding-left: 1.375rem;
  }

  [class*='AutoTableHeaderTh']:last-of-type,
  [class*='AutoTableHeaderTh']:last-child {
    padding-right: 2.25rem;
  }

  ${themeGet('breakpoints.mobileLarge')} {
    [class*='AutoTableHeader']:nth-child(3),
    [class*='Cell']:nth-child(3) {
      display: none;
    }
    [class*='AutoTableHeader']:nth-child(2),
    [class*='Cell']:nth-child(2) {
      padding-left: ${themeGet('spacing.yellow12_0_75rem')};
    }
    [class*='AutoTableHeader']:nth-child(2) {
      width: 31%;
      border-radius: 0 10px 0 0;
    }

    [class*='Row']:last-child {
      [class*='Cell']:nth-child(2) {
        border-radius: 0 0 10px 0;
      }
    }
  }

  ${themeGet('breakpoints.mobileLarge')} {
    [class*='AutoTableHeaderTh']:first-child {
      padding-left: ${themeGet('spacing.yellow12_0_75rem')};
    }

    [class*='Cell']:first-child {
      padding-left: ${themeGet('spacing.yellow12_0_75rem')};
    }

    [class*='Cell']:nth-child(2) {
      padding-right: 0.875rem;
    }
  }

  .cell-icon {
    margin-right: ${themeGet('spacing.pink8_0_5rem')};
    ${themeGet('breakpoints.mobileLarge')} {
      display: none;
    }
  }
`

export const PracticesCompleteText = styled.span`
  margin-bottom: 0.9375rem;
`

export const StyledProgressBarIndicator = styled(ProgressBarIndicator)`
  display: flex;
  flex: 1;
  width: 100%;
  max-width: 400px;
  padding-right: 0.5rem;
  margin-bottom: 0.5rem;

  [class*='Background'] {
    background-color: ${themeGet('colors.linkLight')};
    height: 0.75rem;
    margin-top: 0.125rem;
    width: 100%;
  }

  [class*='BodyCopy'] {
    padding: 0.1875rem 0 0 0.5rem;
  }

  [class*='IndicatorWrapper'] {
    height: 0.75rem;

    [class*='Indicator'] {
      background-color: ${themeGet('colors.hsPrimaryPink')};
      border-color: ${themeGet('colors.hsPrimaryPink')};
      height: 0.75rem;
    }
  }
`

export const StyledHeaderTwo = styled(HeaderTwo)`
  margin-bottom: 0.3125rem;
`

export const TableHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const TextHiddenOverflow = styled.div`
  margin: 0;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const UserPathwaysTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.25rem 1.25rem 2.5rem;
`
